module.exports = __webpack_public_path__ + "static/banner-9a28a73f7e90e24c691573f0bb4b16f1.jpg";